export default {
  listBanks: [],
  bank: {
    numero: '',
    descricao: '',
    logoUrl: '',
    ativo: true,
  },
}
